import React from 'react';
import { NavLink } from 'react-router-dom';
import './navlink.css';

const Navlink = (props) => {

  const getClassName = ({ isActive }) =>
    `sidebar_link${isActive ? ' sidebar_link_active' : ''}`;

  const Icon = props.icon;

  return (
    <li className="sidebar_item">
      <NavLink
        className={getClassName}
        end={props.to === '/'}
        to={props.to}
      >
        <div className="sidebar_hover_circle"></div>

        <Icon className="sidebar_icon" />
        <div className="sidebar_label">{props.linktext}</div>

      </NavLink>
    </li>
  );
};

export default Navlink;
